// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"3e7e67dc","552":"12b32031","955":"1304274d"}[chunkId] + ".chunk.css";
};